import React from 'react'
import { AlertTriangle } from 'lucide-react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
          <div className="flex items-center space-x-2 text-red-700 dark:text-red-300">
            <AlertTriangle className="w-5 h-5" />
            <span className="text-sm font-medium">
              {this.props.fallbackMessage || 'Something went wrong'}
            </span>
          </div>
          {this.props.showError && (
            <p className="text-xs text-red-600 dark:text-red-400 mt-2 font-mono">
              {this.state.error?.message}
            </p>
          )}
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
